module.exports = __webpack_public_path__ + "img/present-white.9e4630db.svg";